import { RolloverDashboardReport } from '../types';

export const transformRolloverDashboardReportData = (
  reportData: RolloverDashboardReport[]
) => {
  const result: any = [];
  let srNo = 1;
  reportData.forEach((record: RolloverDashboardReport) => {
    const transformedRecord: Record<string, any> = {
      'Sr. No.': srNo,
      School: record.school
    };

    if (record.grade) {
      transformedRecord['Grade'] = record.grade;
    }

    Object.assign(transformedRecord, {
      'Total Rollover Users': record.totalRolloverUsers,
      'Form Submitted': record.declarationsSubmittedUsers,
      'Full Payment Selected': record.fullPaymentSelectedUsers,
      'Installments Selected': record.installmentsSelectedUsers,
      'Full Payment Paid': record.fullPaymentPaidUsers,
      'First Installment Paid': record.firstInstallmentPaidUsers,
      'ENACH/PDC Registered': record.enachRegisteredUsers
    });

    if (!record.grade) {
      transformedRecord['Paid Users Percentage'] = record.paidUsersPercentage;
    }

    result.push(transformedRecord);
    srNo++;
  });

  return result;
};
